var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[(_vm.loading)?_c('div',{staticClass:"loading-wrapper"},[_c('updox-loading',{attrs:{"color":"#003462","size":"80px"}})],1):_c('div',[_c('app-header',{on:{"log-out":_vm.logout}}),_c('router-view')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }